import classNames from 'classnames'
import { memo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGlobalStore } from '../../../../../../store/global-store'
import type { LiveGuest } from '../../../../../../types/lives/live'

interface Props {
  guest: LiveGuest
  handleSelectUserToGift: (id: number) => void
}

export const Gifter = memo(({ guest, handleSelectUserToGift }: Props) => {
  const { isSelected } = useGlobalStore(
    useShallow((state) => ({
      // Number(): userId pode chegar string do PG e o Set guarda numbers
      isSelected: state.usersToGift.has(Number(guest?.userId)),
    })),
  )

  const isInvisible = guest?.user?.privacy?.invisibleVisitor

  return (
    <img
      src={!isInvisible ? guest?.user?.imgUser : undefined}
      onClick={() => handleSelectUserToGift(guest.userId)}
      className={classNames('w-8 h-8 rounded-full bg-black', {
        'border-2 border-purple-600': isSelected,
      })}
    />
  )
})
